module.exports = __webpack_public_path__ + "static/media/nz-govt-logo.52b7fb46.png";